import { ReactElement } from "react";
import { ActivityLayout } from "../Layout/ActivityLayout";
import { Typography } from "client/Components";
import { NewEmailNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { setTrackingId } from "client/Misc/utils";

const { Title, SubText } = ActivityLayout;

export type NewEmailActivityProps = {
	data: NewEmailNotificationDataViewModel;
};

export const NewEmailActivity = (props: NewEmailActivityProps): ReactElement => {
	const { data } = props;

	const {
		subject,
		sender
	} = data;

	return (
		<ActivityLayout>
			<Title>
				<Typography
					trackingId="subject"
					weight="bold"
					title={subject}
				>
					{subject}
				</Typography>
			</Title>
			<SubText>
				<span
					{...setTrackingId("sender")}
					title={sender}
				>
					{sender}
				</span>
			</SubText>
		</ActivityLayout>
	);
};

NewEmailActivity.displayName = "NewEmailActivity";